import React from 'react';
import { connect } from 'react-redux';
import { Translate } from 'react-localize-redux';
import { withLocalize } from 'react-localize-redux';
import { bindActionCreators } from 'redux';
import { Circles } from '../../common/loadingComponent';
import { reportActions } from '../../../store/reportStore';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import Summary from './summary';
import Paging from '../../common/pagingComponent';
import Table from './table';

class PublicProcurementsSection extends React.Component {
    state = { page: 1 };

    get section() {
        return this.props.sections.find(o => o.id === this.props.sectionId).subsections.find(q => q.id === this.props.subsectionId);
    }

    get pageSize() {
        const limits = this.props.getSectionLimits(this.props.reportType, this.props.subsectionId);
        return this.section.isLimited ? limits.pageSize.limited : limits.pageSize.unlimited;
    }

    get isSupplier() {
        return this.props.subsectionData.summary.id === "S";
    }

    render() {
        const { data, loadingMoreData, params, isLimited } = this.getSectionFromStore(this.props);
        const loadingType = !isNullOrUndefined(loadingMoreData) && loadingMoreData === true && !isNullOrUndefined(params) && !isNullOrUndefined(params.type)
            ? params.type : null

        return isNullOrUndefined(data) ? null : this.renderWithData(this.isSupplier ? data.supplier : data.announcer, loadingType, isLimited);
    }

    renderWithData = (data, loadingType, isLimited) => {
        const summary = this.props.subsectionData.summary;
        const dataToRender = data.items;
        const tableHeader = this.getTableTitle(summary.id, summary.country);
        const max = isLimited && dataToRender.length > this.pageSize * this.state.page ? this.pageSize * this.state.page : dataToRender.length;
        const typeAbbreviation = this.isSupplier ? 'S' : 'A';
        const type = this.isSupplier ? 'supplier' : 'announcer';

        if (isNullOrUndefined(dataToRender) || dataToRender.length === 0 || summary.summaryRows.length === 0)
            return null;

        if (!isLimited && loadingType === typeAbbreviation)
            return <Circles />

        return (
            <div>
                <Summary data={summary.summaryRows} />
                <Table column={tableHeader} data={dataToRender.slice(0, max)} />
                {isLimited && summary.count > max && this.renderMoreLinks(summary.count, loadingType, typeAbbreviation, type)}
                {!isLimited && summary.count > this.pageSize && <div style={{ marginTop: "2em" }}>
                    <Paging
                        justify="center"
                        selectedPage={this.state.page}
                        totalPages={Math.ceil(summary.count / this.pageSize)}
                        setPage={page => this.onChangePage(page, typeAbbreviation, type)}
                    />
                </div>}
            </div>
        )
    }

    getTableTitle = (type, country) => {
        if (type === "A")
            return country === "SK" ? "Report.Procurements.Supplier" : "Report.Procurements.Winner";
        if (type === "S")
            return country === "SK" ? "Report.Procurements.Announcer" : "Report.Procurements.Submitter";
        return null;
    }

    renderMoreLinks = (totalCount, loadingType, typeAbbreviation, type) => {
        return (
            <>
                <div>
                    {this.state.page === 1 && <span className="link-functional" onClick={() => this.getMore(typeAbbreviation, type)}>
                        <Translate id="Report.Common.More" />
                    </span>}
                    {this.state.page === 2 && <a className="link-functional" target="_blank"
                        href={this.props.getUnlimitedSectionLink(this.props.reportType, this.props.id, this.props.sectionId)}
                    >
                        <Translate id="Report.Common.ShowAll" />&nbsp;({totalCount})
                    </a>}
                </div>
                {((this.isSupplier && loadingType === 'S') || (!this.isSupplier && loadingType === 'A')) &&
                    <div style={{ width: "100%"}} className="search-progress searching"></div>}
            </>
        )
    }

    getMore = (typeAbbreviation, type) => {
        this.props.fetchMoreData(
            [this.props.sectionId, this.props.subsectionId],
            { count: this.pageSize, offset: this.pageSize, report: this.props.reportType, type: typeAbbreviation },
            type, this.concatData, () => this.setState({ page: 2 })
        );
    }

    onChangePage = (page, typeAbbreviation, type) => {
        this.props.fetchMoreData(
            [this.props.sectionId, this.props.subsectionId],
            { count: this.pageSize, offset: (page - 1) * this.pageSize, report: this.props.reportType, type: typeAbbreviation },
            type, this.replaceData, () => this.setState({ page: page })
        );
    }

    concatData = (dataKey, oldData, newData) => {
        let data = {
            count: oldData[dataKey].count,
            items: oldData[dataKey].items.concat(newData[dataKey].items),
            stats: oldData[dataKey].stats
        };
        return { ...oldData, [dataKey]: data }
    }

    replaceData = (dataKey, oldData, newData) => {
        let data = {
            count: oldData[dataKey].count,
            items: newData[dataKey].items,
            stats: oldData[dataKey].stats
        };
        return { ...oldData, [dataKey]: data }
    }

    getSectionFromStore = props => props.sections.find(o => o.id === props.sectionId).subsections.find(q => q.id === props.subsectionId);
}

export default withLocalize(connect(
    state => state.report,
    dispatch => bindActionCreators(reportActions, dispatch)
)(PublicProcurementsSection));